module.exports = __webpack_public_path__ + "static/media/fiveforces.405cbbce.jpeg";